import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import CommonTableGraph from '../../../../charts/CommonTableGraph';
const HConfigTab = ({ deviceHistory }) => {
    const config = deviceHistory?.config ?? [];
    let tableFormat = config.map((row) => {
        return {
            Change: row.attribute,
            From: row.from,
            To: row.to,
            Account: row.user,
            _Time: row.timestamp,
        };
    });
    if (tableFormat.length === 0) {
        tableFormat = [{ Config: 'No changes found', _Time: undefined }];
    }
    return _jsx(CommonTableGraph, { data: tableFormat });
};
export default HConfigTab;
